<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({
                      name: 'AdministratorUsersCollectorsCreate',
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon small left>mdi-plus</v-icon>
                {{ $t("newCollector") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
          </template>

          <template v-slot:item.nome="{ item }">
            <a
              class="light-green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  'administrator/collectors/getCollector'
                )
              "
            >
              <v-icon color="light-green" small>mdi-account-cash</v-icon>
              {{ item.nome }}
            </a>
          </template>

          <template v-slot:item.id_regional="{ item }">
            <v-btn @click="$copy(item.id_regional)" x-small>{{
              item.id_regional
            }}</v-btn>
          </template>

          <template v-slot:item.data_cadastro="{ item }">
            <div class="caption">
              {{ item.data_cadastro }}
            </div>
          </template>

          <!-- Column Action -->
          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-btn
                small
                :title="$t('routesToCollect')"
                @click="
                  [
                    $router.push({
                      name: 'AdministratorUsersCollectorsRoutesToCollect',
                      params: { id_collector: item.id },
                      query: { name_collector: item.nome },
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon>mdi-routes</v-icon>
              </v-btn>

              <v-btn
                small
                :title="$t('closings')"
                @click="
                  $router.push({
                    name: 'AdministratorFinancialLaunches',
                    query: {
                      id_collector: item.id,
                      id_regional: item.id_regional,
                    },
                  })
                "
              >
                <v-icon>mdi-receipt</v-icon>
              </v-btn>
              <v-btn
                small
                :title="$t('profile')"
                @click="
                  $profile.showProfileDrawer(
                    item.id,
                    'administrator/collectors/getCollector'
                  )
                "
              >
                <v-icon>mdi-account-cash</v-icon>
              </v-btn>
              <v-btn
                small
                :title="$t('edit')"
                @click="
                  [
                    $router.push({
                      name: 'AdministratorUsersCollectorsEdit',
                      params: { id: item.id },
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon size="24">mdi-pencil</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "administrator-users-collectors-list",
  components: {
    HeaderPrint,
  },
  data: () => ({
    items: [],
    search: "",
  }),

  computed: {
    headers() {
      return [
        { text: "ID", value: "id" },
        { text: this.$t("name"), value: "nome" },
        { text: this.$t("login"), value: "login" },
        { text: this.$t("regionalIdManager"), value: "id_regional" },
        { text: this.$t("createdIn"), value: "data_cadastro" },
        {
          text: this.$t("actions"),
          value: "action",
          align: "center d-print-none",
        },
      ];
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    refresh(val) {
      val && this.getCollectorsList();
      this.$store.commit("setRefresh", false);
    },
    saveFilters(val) {
      val && this.getCollectorsList();
    },
  },
  methods: {
    resetPage() {
      this.search = "";
    },

    async getCollectorsList() {
      this.resetPage();
      const body = {
        id_regional: this.id_regional,
      };
      const request = await this.$request.post(
        "/administrator/collectors/list",
        body
      );
      this.items = request.length == 0 ? [] : request.dados;
      this.items = this.items.map((item) => {
        item.data_cadastro = new Date(
          item.data_cadastro.replace(" ", "T")
        ).toLocaleString();
        return item;
      });
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
  },
};
</script>
